import { createContext, useContext } from 'react';

export const PageBannerTarget = createContext<HTMLDivElement | null>(null);

export function usePageBannerTarget() {
  return useContext(PageBannerTarget);
}
